import React from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from '../hooks/useAuth'
import { useAuthStore } from '../store/authStore'
import { LoadingSpinner } from './LoadingSpinner'

interface ProtectedAdminRouteProps {
  children: React.ReactNode
}

export const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  const { user } = useAuthStore()
  const location = useLocation()

  // Mostrar loading mientras se valida la autenticación
  if (isLoading) {
    return <LoadingSpinner message="Verificando autenticación..." />
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Si no es ADMIN, redirigir al dashboard (o página de inicio del usuario)
  if (user?.rol !== 'ADMIN') {
    const homePage = user?.pagina_inicio || '/dashboard'
    return <Navigate to={homePage} replace />
  }

  return <>{children}</>
}

